import { hydrateRoot } from 'react-dom/client';
import * as tracking from 'dibs-tracking';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay/legacy.js';
import { TABLET, MOBILE, DESKTOP } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';
import { designSeriesRoot } from '../designSeries/designSeriesRoot.ts';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { ServerVarsContextProvider } from '../sharedComponents/ServerVarsContext.tsx';

// components
import { DesignSeriesLayout } from '../designSeries/DesignSeriesLayout.tsx';

import { type designSeriesRootQuery$variables } from '../designSeries/__generated__/designSeriesRootQuery.graphql.ts';
import { type DesignSeriesLayout_viewer$key } from '../designSeries/__generated__/DesignSeriesLayout_viewer.graphql.ts';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables: designSeriesRootQuery$variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(designSeriesRoot), variables);
const snapshot = environment.lookup(operation.fragment);
const deviceType = serverVars.get('deviceType');

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ServerVarsContextProvider
                isMobile={deviceType === MOBILE}
                isDesktop={deviceType === DESKTOP}
                isTablet={deviceType === TABLET}
            >
                <ReactRelayContext.Provider
                    value={{
                        // @ts-ignore
                        variables,
                        environment,
                    }}
                >
                    <DesignSeriesLayout
                        viewer={snapshot?.data?.viewer as DesignSeriesLayout_viewer$key}
                    />
                </ReactRelayContext.Provider>
            </ServerVarsContextProvider>
        </IntlProvider>
    );

    tracking.trackPageview({
        additional: {
            pageType: 'Content',
            pageSubType: 'Design Series',
        },
    });
});
